export function displaySquare(fn: Function) {
	console.log('Square is ' + fn(5));
}

// IIFE
(function square(num: number): number {
	return num * num;
})(5);

// Function Scope
var num1 = 20,
	num2 = 30,
	name: 'ok';

function multiply() {
	return num1 * num2;
}

function getScore() {
	var num1 = 2;
	num2 = 3;
	function add() {
		return name + 'scord' + (num1 + num2);
	}
	return add();
}
multiply();

// for (let i = 0; i < 5; i++) {
// 	setTimeout(() => {
// 		console.log(i);
// 	}, i * 1000);
// }
